module.exports = __webpack_public_path__ + "static/animated-logo-58affa05ec7a57ef398f3cb45fd68c74.mp4";